import MenuHero from "../components/Menu/MenuHero";
import MenuSection from "../components/Menu/MenuSection";
import MenuPdfSection from "../components/Menu/MenuPdfSection";
import { menuData } from "../components/Menu/menuData";
export default function Menu() {
  return (
    <div>
      <MenuHero />
      {/* {menuData.map((sec, index) => (
        <MenuSection
          key={index}
          title={sec.title}
          verticalTitle={sec.verticalTitle}
          image={sec.image}
          items={sec.items}
          reverse={sec.reverse}
        />
      ))} */}
      <MenuPdfSection
        title="Our Full Menu"
        pdfUrl="/menu.pdf"
      />

    </div>
  );
}
